import { HeistLocation, HeistReward, HeistSkill } from "../../models/item-data-models";

export const heistLocations: { name: HeistLocation, skills: HeistSkill[] }[] = [
  {
    name: 'Bunker',
    skills: [
      'agility',
      'counter-thaumaturgy',
      'engineering',
      'demolition',
      'lockpicking',
      'perception',
      'trap-disarmament',
    ]
  },
  {
    name: 'Records Office',
    skills: [
      'brute-force',
      'counter-thaumaturgy',
      'deception',
      'demolition',
      'lockpicking',
      'trap-disarmament',
    ]
  },
  {
    name: 'Mansion',
    skills: [
      'agility',
      'brute-force',
      'deception',
      'lockpicking',
      'perception',
    ]
  },
  {
    name: 'Smuggler\'s Den',
    skills: [
      'brute-force',
      'deception',
      'demolition',
      'perception',
      'trap-disarmament',
    ]
  },
  {
    name: 'Underbelly',
    skills: [
      'agility',
      'brute-force',
      'deception',
      'demolition',
      'engineering',
    ]
  },
  {
    name: 'Laboratory',
    skills: [
      'counter-thaumaturgy',
      'engineering',
      'deception',
      'demolition',
      'perception',
    ]
  },
  {
    name: 'Prohibited Library',
    skills: [
      'counter-thaumaturgy',
      'deception',
      'engineering',
      'lockpicking',
      'perception',
    ]
  },
  {
    name: 'Repository',
    skills: [
      'agility',
      'demolition',
      'lockpicking',
      'perception',
      'trap-disarmament',
    ]
  },
  {
    name: 'Tunnels',
    skills: [
      'agility',
      'brute-force',
      'counter-thaumaturgy',
      'demolition',
      'engineering',
      'trap-disarmament',
    ]
  }
];

export const heistRewards: { skill: HeistSkill, rewards: HeistReward[] }[] = [
  {
    skill: 'lockpicking',
    rewards: [
      'currency',
      'fragments',
      'jewellery',
    ]
  },
  {
    skill: 'counter-thaumaturgy',
    rewards: [
      'currency',
      'gems',
      'jewellery',
    ]
  },
  {
    skill: 'trap-disarmament',
    rewards: [
      'currency',
      'armour',
      'weapons',
      'breach',
      'abyss',
      'legion',
      'talisman',
    ]
  },
  {
    skill: 'deception',
    rewards: [
      'harbinger',
      'divination',
      'armour',
    ]
  },
  {
    skill: 'agility',
    rewards: [
      'harbinger',
      'armour',
      'delve',
      'essence',
    ]
  },
  {
    skill: 'perception',
    rewards: [
      'divination',
      'jewellery',
      'random',
    ]
  },
  {
    skill: 'engineering',
    rewards: [
      'maps',
      'uniques',
      'essence',
      'random',
    ]
  },
  {
    skill: 'brute-force',
    rewards: [
      'uniques',
      'weapons',
      'delve',
    ]
  },
  {
    skill: 'demolition',
    rewards: [
      'ultimatum',
      'delirium',
      'blight',
      'random'
    ]
  }
];
